import React, { useState, useEffect } from "react";
import { getTokenExpiration } from "../authHelper";
import "./AuthLabel.scss";

export const AuthLabel = ({ tokenKey, label, colorClass }) => {
  const [hasToken, setHasToken] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);

  const formatTimeRemaining = (milliseconds) => {
    const totalMinutes = Math.floor(milliseconds / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  };

  useEffect(() => {
    const checkToken = () => {
      const token = window.localStorage.getItem(tokenKey);

      if (token && token.length > 10) {
        setHasToken(true);
        const expirationTime = getTokenExpiration(tokenKey);

        if (expirationTime) {
          const remaining = expirationTime - Date.now();
          setTimeRemaining(remaining > 0 ? remaining : 0);
        }
      } else {
        setHasToken(false);
        setTimeRemaining(null);
      }
    };

    // Check on mount
    checkToken();

    // Update countdown every minute
    const interval = setInterval(() => {
      checkToken();
    }, 60000);

    // Check when localStorage changes
    window.addEventListener("storage", checkToken);

    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", checkToken);
    };
  }, [tokenKey]);

  if (!hasToken) {
    return null;
  }

  return (
    <div className={`auth-label ${colorClass}`}>
      <span className="auth-label-text">
        <strong>{label}:</strong>
        {timeRemaining !== null && timeRemaining > 0 && (
          <span className="token-expiry"> Session expires in {formatTimeRemaining(timeRemaining)}</span>
        )}
        {timeRemaining !== null && timeRemaining <= 0 && <span className="token-expired">Token expired</span>}
      </span>
    </div>
  );
};
